define(['text!./templates/Heading.html'], heading => [() => ({
    restrict: 'E',
    replace: true,
    transclude: true,
    template: heading,
    scope: {}
})]);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/titles/Heading.js